@use "styles" as *;

.me-main-layout {
  min-height: 100vh;
  display: grid;
  grid:
      ". header ." auto
      ". . ." space(5)
      ". breadcrumbs ." auto
      ". . ." space(5)
      ". main ." 1fr
      ". . ." space(30)
      "footer footer footer" auto
      / minmax(0, 1fr) minmax(0, $container-max-width) minmax(0, 1fr);

  @include print {
    display: block;
  }

  &__header {
    grid-area: header;
  }

  &__breadcrumbs {
    grid-area: breadcrumbs;
    padding: 0 $main-padding space(5);

    &:empty {
      display: none;
    }
  }

  &__main {
    grid-area: main;
    padding: 0 $main-padding;

    > *[slot=main] {
      @include remove-first-and-last-child-margins;
      @include block-margins;
    }
  }

  &__footer {
    grid-area: footer;
  }
}
